import {Form, FormField, FormSubmitHandler} from 'platform/components';
import {Box, HStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {jobInputFormSchema, JobInputFormType} from '../../types/jobInputFormSchema';

export type JobInputForm = JobInputFormType;

interface CustomJobProps extends TestIdProps {
  onSubmit: FormSubmitHandler<JobInputForm>;
}

export function JobInput(props: CustomJobProps) {
  const handleSubmit: FormSubmitHandler<JobInputForm> = (values, setErrors, reset) =>
    props.onSubmit({...values}, setErrors, reset).then(() => reset());

  return (
    <Form<JobInputForm>
      experimentalZodSchema={jobInputFormSchema}
      onSubmit={handleSubmit}
      data-testid={suffixTestId('job', props)}
    >
      {(control, formApi) => {
        const isFormValid = formApi.formState.isValid;

        return (
          <HStack spacing={2} align="flex-end" width="100%">
            <Box flex={1}>
              <FormField
                control={control}
                name="job"
                type="text"
                isDisabled={formApi.formState.isSubmitting}
                placeholder={i18n.t('entity.orderRequest.labels.customRequestPlaceholder')}
                data-testid={suffixTestId('job', props)}
                rightButtonProps={{
                  type: 'submit',
                  title: i18n.t('general.actions.enter'),
                  leftIcon: 'navigation/subdirectory_arrow_left',
                  size: 'small',
                  variant: isFormValid ? 'primary' : 'secondary',
                  isLoading: formApi.formState.isSubmitting,
                  isDisabled: !isFormValid,
                }}
              />
            </Box>
          </HStack>
        );
      }}
    </Form>
  );
}
